import DynamicTag from '@molecules/DynamicTag/DynamicTag'
import TopInfoBanner from '@molecules/TopInfoBanner/TopInfoBanner'
import NavItemComponent from './NavItem/NavItem'
import RichTextComponent from './RichText/RichTextComponent'
import { ComponentMapping } from '@common-types/ComponentMapping'
import CustomLinkComponent from '@atoms/CustomLink/CustomLinkComponent'
import SliderCarousel from '@organisms/SliderCarousel/SliderCarousel'
import ButtonWrapper from './ButtonWrapper/ButtonWrapper'
import HeadlineSubline from '@molecules/HeadlineSubline/HeadlineSubline'
import { ImageTextComponent } from '@molecules/ImageText/ImageText'
import Footer from './Footer'
import {
  HotSpotBubbleWrapper,
  HotSpotCanvasWrapper
} from './HotSpotWrapper/HotSpotWrapper'
import TopNewsBannerComponent from '@molecules/TopNewsBanner/TopNewsBanner'
import StoreLocator from '@organisms/StoreLocator/StoreLocator'
import AccordionWrapper from '@molecules/AccordionWrapper/AccordionWrapper'
import ProductSpecsWrapper from './ProductSpecsWrapper/ProductSpecsWrapper'
import GridWrapper from './GridWrapper/GridWrapper'
import NewsletterModal from '@organisms/NewsletterModal/NewsletterModal'
import NewsletterWrapper from './NewsletterWrapper/NewsletterWrapper'
import NewsletterSignup from './NewsletterSignup/NewsletterSignup'
import ContactForm from '@molecules/ContactForm/ContactForm'
import JsonLdWrapper from './JsonLd/JsonLdWrapper'
import ProductSpecsLinkWrapper from './ProductSpecsLink/ProductSpecsLinkWrapper'
import PopupContent from '@organisms/PopupContent/PopupContent'
import TopNewsletterBanner from '@molecules/TopNewsletterBanner/TopNewsletterBanner'

const defaultComponentMapping: ComponentMapping = {
  'pwa.accordion': AccordionWrapper,
  'pwa.richText': RichTextComponent,
  'pwa.customLink': CustomLinkComponent,
  'pwa.dynamicTagLink': DynamicTag,
  'pwa.navItem': NavItemComponent,
  'pwa.topInfoBanner': TopInfoBanner,
  'pwa.sliderCarousel': SliderCarousel,
  'pwa.button': ButtonWrapper,
  'pwa.headlineSubline': HeadlineSubline,
  'pwa.imageText': ImageTextComponent,
  'pwa.Footer': Footer,
  'pwa.hotSpotBubble': HotSpotBubbleWrapper,
  'pwa.hotSpotCanvas': HotSpotCanvasWrapper,
  'pwa.topNewsBanner': TopNewsBannerComponent,
  'pwa.storeLocator': StoreLocator,
  'pwa.productSpecs': ProductSpecsWrapper,
  'pwa.grid': GridWrapper,
  'pwa.newsletter': NewsletterModal,
  'pwa.newsletterForm': NewsletterWrapper,
  'pwa.newsletterSignup': NewsletterSignup,
  'pwa.contactForm': ContactForm,
  'pwa.jsonLd': JsonLdWrapper,
  'pwa.productSpecsLink': ProductSpecsLinkWrapper,
  'pwa.popupContent': PopupContent,
  'pwa.topNewsletterBanner': TopNewsletterBanner
}

export default defaultComponentMapping
